import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { useHistory } from 'react-router';
import { PropsFromRedux } from '.';
import checkImg from '../../assets/images/success-ribbons.svg';
import { API_KEYS } from '../../interfaces/api';
import { USER } from '../../interfaces/auth.interface';
import { WALLET_RESPONSE } from '../../interfaces/wallet.interface';
import { formatMoney } from '../../utils/common.utils';
import { Spinner } from '../Spinners/Spinner';


interface Props extends PropsFromRedux {}

const CodAccountSuccess: React.FC<Props> = ({ 
    hideModal,
    showModal,
    modal,
    user,
    walletShipments,
    checkUserCodExist,
    checkUserCodExistState,
    resetApi
    
 }) => {

    const amount = modal?.ownProps?.amount;
    const userObj: USER = user?.response?.Object;
    const history = useHistory();
    const shipmentObject: WALLET_RESPONSE = walletShipments?.response?.Object;

  //   React.useEffect(
  //     () => () => {
  //       resetApi(API_KEYS.CHECK_USER_COD_EXIST);
  //     },
  //     [resetApi]
  // );

  const closeModal = () => {
    hideModal();
    checkUserCodExist(userObj?.UserChannelCode);
  }

  React.useEffect(() => {
    if(checkUserCodExistState?.success &&  checkUserCodExistState?.response?.Object){
      history.push('/cod-account');
    }
  }, [checkUserCodExistState?.success, checkUserCodExistState?.response?.Object])
  

  if (checkUserCodExistState?.loading)  {
    return (
      <div className="w-full flex items-center justify-center pt-4 overflow-hidden">
        <Spinner />
      </div>
    );
  }

  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return(
    <div className="w-full px-2 bg-white lg:px-20 py-10 relative">
        <button type="button" aria-label="Close" onClick={closeModal}>
         <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>
    <div className="w-full my-2 flex items-center justify-center ">
      <img src={checkImg} alt="GIG App" className="w-48 my-4" />
    </div>
     <div className="w-full my-4 text-center">
         <h2 className="mb-1 text-lg font-semibold text-black">Successful</h2>
         <p className="text-xs text-gray-500 my-2">
         Your COD wallet setup with stellas bank was successful.</p>
      </div>
      {/* <button className="w-full bg-orange-600 font-medium text-sm rounded text-white py-3" type="button" onClick={() => closeModal()}>Download Stellas Bank App</button> */}
      <button className="w-full bg-gray-100 font-medium text-sm font-bold rounded text-black py-3" type="button" onClick={() => closeModal()}>Go to COD Wallet</button>
  </div>
  );

  
  // </ModalWrapper>
};

export default CodAccountSuccess;
